import WordVerify from './src/word-verify';

WordVerify.install = function(Vue) {
	Vue.component(WordVerify.name, WordVerify);
};

export default WordVerify;



// WEBPACK FOOTER //
// ./src/components/word-verify/index.js